import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import uuid from 'uuid';

let globalRefs = [];

const withOutsideClick = ChildComponent => {
  // const factory = createFactory(component);
  const id = uuid();

  return class ComposedComponent extends Component {
    componentDidMount() {
      const { onClickOutside } = this.props;
      window.addEventListener('click', this.handleClickOutside);
      globalRefs.push({
        id,
        click: onClickOutside
      });
    }

    // When the attribute 'show' of any component changes from false to true,
    // the rest of components have to be hidden
    componentDidUpdate(prevProps) {
      const { show } = this.props;
      const { show: prevShow } = prevProps;
      if (!prevShow && show) {
        globalRefs.filter(ref => ref.id !== id).forEach(ref => ref.click());
      }
    }

    componentWillUnmount() {
      window.removeEventListener('click', this.handleClickOutside);
      globalRefs = globalRefs.filter(ref => ref.id !== id);
    }

    // If the clicked element is inside the component, don't fire onClickOutside
    handleClickOutside = ({ target }) => {
      const { ref } = this;
      const { onClickOutside } = this.props;
      const targetElement = ReactDOM.findDOMNode(ref);
      if (targetElement !== target && !targetElement.contains(target)) {
        onClickOutside();
      }
    };

    render() {
      return (
        <div
          ref={r => {
            this.ref = r;
          }}
        >
          <ChildComponent {...this.props} />
        </div>
      );
    }
  };
};

export default withOutsideClick;
